import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { CardHeader, Flex, Heading } from "@chakra-ui/react";
import { Card } from "primereact/card";
import { useSelector } from "react-redux";
import { Dropdown } from "primereact/dropdown";
export default function Completed() {
  const [tasks, setTasks] = useState(null);
  const dt = useRef(null);
  const [departments, setDepartments] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState("");
  const [users, setUsers] = useState([]);
  const userData = useSelector((state) => state.UserReduce.value);
  const departmentData = useSelector((state) => state.DepartmentReduce.value);
  const taskData = useSelector((state) => state.TaskReduce.value);
  const customerData = useSelector((state) => state.CustomerReduce.value);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setTasks(taskData);
        setUsers(userData);
        setDepartments(departmentData);
        setCustomers(customerData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [taskData, userData, departmentData, customerData]);

  const statusBodyTemplate = (rowData) => {
    const getStatusLabel = (status) => {
      switch (status) {
        case "0":
          return "Boşta";
        case "1":
          return "İşlemde";
        case "2":
          return "Tamamlamdı";
        default:
          return null;
      }
    };
    const statusLabel = getStatusLabel(rowData.status);
    return <Tag value={statusLabel} severity={getStatus(rowData)}></Tag>;
  };

  const getStatus = (tasks) => {
    switch (tasks.status) {
      case "0":
        return "danger";
      case "1":
        return "warning";
      case "2":
        return "success";
      default:
        return null;
    }
  };
  const searchEmpInTask = async (value) => {
    if (Array.isArray(taskData) && taskData.length > 0) {
      const matchingTasks = taskData.filter((task) => {
        if (typeof task.designated_person === "string") {
          const designatedPersons = task.designated_person
            .split(",")
            .map((person) => person.trim());
          return designatedPersons.includes(value.toString());
        }
        return false;
      });
      setTasks(matchingTasks);
    }
  };
  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
    };
    return new Date(dateString).toLocaleString("tr-TR", options);
  };

  return (
    <div>
      <Flex justifyContent="center" alignItems="center">
        <div
          className="card"
          style={{
            overflow: "auto",
            boxSizing: "border-box",
            width: "100%",
            height: "100%%",
            position: "relative",
          }}
        >
          <Card style={{ textAlign: "left" }}>
            <CardHeader>
              <Flex justifyContent="space-between" alignItems="center">
                <Heading size="md" style={{ color: "black" }}>
                  Tamamlanan Görevler
                </Heading>
                <div style={{ display: "flex" }}>
                  <Dropdown
                    filter
                    value={search}
                    options={
                      Array.isArray(users) && users.length > 0
                        ? users.map((employ) => ({
                            label: employ.name,
                            value: employ.id,
                          }))
                        : []
                    }
                    placeholder="Çalışana Göre Filtrele"
                    className="w-full "
                    style={{
                      border: "1px solid gray",
                      width: "100%",
                      marginBottom: "1rem",
                    }}
                    onChange={(e) => {
                      setSearch(e.target.value);
                      searchEmpInTask(e.target.value);
                    }}
                  />
                </div>
              </Flex>
            </CardHeader>
            <DataTable
              stripedRows
              tableStyle={{ maxWidth: "85vw" }}
              size="small"
              ref={dt}
              value={
                tasks && tasks.filter((tasks) => Number(tasks.tasks_id) === 2)
              }
              dataKey="id"
              paginator
              rows={15}
              rowsPerPageOptions={[15, 30, 60, 100]}
              scrollHeight="60vh"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="{totalRecords} görevden {first} - {last} arası gösteriliyor"
            >
              <Column
                field="title"
                header="Müşteri"
                body={(rowData) => {
                  const cust = customers?.find(
                    (dept) => dept.id.toString() === rowData.name
                  );
                  if (cust) {
                    const firstTwoWords =
                      cust.title && cust.title.split(" ").slice(0, 2).join(" ");
                    return firstTwoWords;
                  } else {
                    return "Bilinmeyen";
                  }
                }}
              ></Column>
              <Column
                field="desc"
                header="Açıklama"
                style={{ maxWidth: "20rem" }}
              ></Column>
              <Column
                sortable
                field="department_name"
                header="Departman"
                body={(rowData) => {
                  const department = departments.find(
                    (dept) => dept.id.toString() === rowData.department
                  );
                  return department
                    ? department.department
                    : "Unknown Department";
                }}
                style={{ minWidth: "6rem" }}
              ></Column>
              <Column
                header="Bitiren Kişi"
                field="designated_person"
                sortable
                body={(rowData) => {
                  if (rowData.designated_person) {
                    const designatedPersons =
                      rowData.designated_person.split(",");

                    const assignedUsers = designatedPersons.map(
                      (designatedPerson) => {
                        const user = users.find(
                          (usr) => usr.id.toString() === designatedPerson.trim()
                        );
                        return user ? user.name : "Bilinmeyen";
                      }
                    );
                    return assignedUsers.join(", ");
                  } else {
                    return "";
                  }
                }}
                style={{ minWidth: "6rem" }}
              ></Column>
              <Column
                field="status"
                header="Durum"
                body={statusBodyTemplate}
                style={{ minWidth: "6rem" }}
              ></Column>
              <Column
                sortable
                field="created_at"
                header="Oluşturulma Tarihi"
                body={(rowData) => formatDate(rowData.created_at)}
                style={{ minWidth: "6rem" }}
              ></Column>
            </DataTable>
          </Card>
        </div>
      </Flex>
    </div>
  );
}
